import { useTranslation } from '@spcc/core'
import { Download } from '@spcc/uikit'
import { PageHeader } from '@spcc/uikit'
import type { ShipmentsHeaderProps } from '../types'

export function ShipmentsHeader({ isArabic, onExport }: ShipmentsHeaderProps) {
  const { t } = useTranslation()

  return (
    <PageHeader
      title={t('shipments.title')}
      subtitle={t('shipments.subtitle')}
      isRTL={isArabic}
      actions={[
        {
          label: t('common.export'),
          icon: Download,
          onClick: onExport,
          variant: 'outline',
        },
      ]}
    />
  )
}
